import { Divider, Grid, Card, CardContent, Box, Stack } from "@mui/material"
import { Labeled, TextField } from 'react-admin'
import MailTextShowActions from "./mailServiceConfig/MailTextShowActions"


const textFields = [
  <TextField whiteSpace={'pre-line'} source="textModelEmail.sendInvoiceEmailText" label="resources.textTemplates.sendInvoiceEmailText" emptyText="-" />,
  <TextField whiteSpace={'pre-line'} source="textModelEmail.sendReverseInvoiceEmailText" label="resources.textTemplates.sendReverseInvoiceEmailText" emptyText="-" />,
  <TextField whiteSpace={'pre-line'} source="textModelEmail.sendInvoiceReminderEmailTextStep1" label="resources.textTemplates.sendInvoiceReminderEmailTextStep1" emptyText="-" />,
  <TextField whiteSpace={'pre-line'} source="textModelEmail.sendInvoiceReminderEmailTextStep2" label="resources.textTemplates.sendInvoiceReminderEmailTextStep2" emptyText="-" />,
  <TextField whiteSpace={'pre-line'} source="textModelEmail.sendInvoiceReminderEmailTextStep3" label="resources.textTemplates.sendInvoiceReminderEmailTextStep3" emptyText="-" />
]

const EmailTextShow = () => {
  return (
    <Stack>
      <Grid container justifyItems={"stretch"}>
        {
          textFields.map(textField => (
            <Grid item mb={2} mr={2} >
              <Labeled component={Box} label={textField.props.label} height={"100%"} >
                <Card sx={{width:500, height:"100%"}} >
                  <CardContent>
                    {textField}
                  </CardContent>
                </Card>
              </Labeled>
            </Grid>
          ))
        }
      </Grid>
      <Divider />
      <MailTextShowActions />
    </Stack>
  )
}

export default EmailTextShow